import React, { useEffect, useState } from 'react';
import PageTab from '../../components/dashboard/PageTab';
import PageTabTitle from '../../components/dashboard/PageTabTitle';
import PageTabBody from '../../components/dashboard/PageTabBody';
import DocumentLink from '../../components/documents/DocumentLink';

const ArchiveDocuments = () => {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    try {
      const context = require.context('/public/archiveDocuments', false);
      const docs = context.keys();

      setDocuments(docs);
    } catch (error) {
      console.error("Directory '/public/archiveDocuments' does not exist.");
    }
  }, []);

  return (
    <PageTab>
      <PageTabTitle>Mokesčių dokumentai</PageTabTitle>
      <PageTabBody>
        {documents.map((filename, index) => (
          <DocumentLink key={index} directory={'/archiveDocuments'} filename={filename} />
        ))}
      </PageTabBody>
    </PageTab>
  );
};

export default ArchiveDocuments;
